import React from 'react';
import './AboutUs.css';

function AboutUs() {
  return (
    <section className="about-us-section" id="about-us-section">
      <div className="container">
        <h2>Quiénes Somos</h2>
        <div className="about-content">
          <p>
            En BH La Marca del Panadero, somos líderes en la fabricación y distribución de maquinaria de panificación de alta calidad en Argentina. Con años de experiencia en el sector, nos dedicamos a ofrecer soluciones innovadoras y confiables para panaderías y confiterías de todos los tamaños.
          </p>
          <p>
            Nuestra misión es potenciar la producción de nuestros clientes, brindando equipos robustos, precisos y eficientes, diseñados para optimizar cada etapa del proceso de elaboración. Creemos en la calidad, la durabilidad y el soporte constante a quienes confían en nuestros productos.
          </p>
          <p>
            Contamos con un equipo de profesionales apasionados y un compromiso inquebrantable con la excelencia. Apostamos por la industria nacional, fabricando en Argentina y asegurando repuestos y soporte técnico directo en todo el país. Su crecimiento es nuestro objetivo.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
